import { assignStudioQuery } from '.';
import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import { IApiReferenceRes } from '../../model/api-modules';
import {
  IRechargeHistoryItem,
  IMidasAccountInfo,
} from '../../model/billing-center';
import {
  BILLING_PREFIX,
  BILLING_PROXY_EDIT,
  BILLING_PROXY_VIEW,
} from '../config';

// 获取专属汇款账号
export const getReferenceID = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/account/get_reference_id`
      );
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
      });
      const res = await parsedResponse<IApiReferenceRes>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getReferenceInfo', error);
      return null;
    }
  });

// 创建专属汇款账号
export const createReferenceID = (
  studioId: string,
  companyName: string,
  cellphone: string
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_EDIT}/api/account/create_reference_id`
      );
      const response = await api.commonRequest('POST', url, {
        studio_id: studioId,
        company_name: companyName,
        cellphone,
      });
      const res = await parsedResponse<string>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getReferenceInfo', error);
      return null;
    }
  });

// 开通midas账户
export const createMidasAccount = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${BILLING_PREFIX}/account/${studioId}/midas?studio_id=${studioId}`;
      const response = await api.commonRequest('POST', url, {
        studio_id: studioId,
      });
      const res = await parsedResponse<IAPIresponse>(response, 'all');
      return res;
    } catch (error) {
      console.log('failed: createMidasAccount', error);
      return null;
    }
  });

// 获取midas账户信息
export const getMidasAccountInfo = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/account/midas_account_info`,
        studioId
      );
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
      });
      const res = await parsedResponse<IMidasAccountInfo>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getMidasAccountInfo', error);
      return null;
    }
  });

// 获取对公汇款记录-列表  page：页码,size：数量
export const getRechargeHistoryList = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/account/charge_history`
      );
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
        page: 1,
        size: 9999,
      });
      const res = await parsedResponse<IRechargeHistoryItem>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getRechargeHistoryList', error);
      return null;
    }
  });
